/* Loot rarity colors, shared by the Items & Consumables page and the character builder's loot list. */

export interface ColorEntry {
  bg: string;
  color: string;
}

export const RARITY_COLORS: Record<string, ColorEntry> = {
  Common: { bg: 'rgba(168,168,168,0.12)', color: '#aaaaaa' },
  Uncommon: { bg: 'rgba(96,216,144,0.14)', color: '#60d890' },
  Rare: { bg: 'rgba(106,174,255,0.14)', color: '#6aaeff' },
  Legendary: { bg: 'rgba(201,162,39,0.18)', color: '#e8c547' },
};

/** Rarest last, as the loot tables roll them. */
export const RARITIES = Object.keys(RARITY_COLORS);

export const RARITY_COLORS_LIGHT: Record<string, ColorEntry> = {
  Common: { bg: 'rgba(100,100,100,0.1)', color: '#525252' },
  Uncommon: { bg: 'rgba(22,101,52,0.1)', color: '#166534' },
  Rare: { bg: 'rgba(29,78,216,0.1)', color: '#1d4ed8' },
  Legendary: { bg: 'rgba(146,64,14,0.12)', color: '#92400e' },
};
